export const environment = {
    host: '',
    name: 'Production',
    serverHost: 'http://web:8000',
    production: true,
    preview: false,
    sentryBrowserDSN:
        'https://d40a027d349249fda0c8736de4503873@o381861.ingest.sentry.io/5212684',
    contentful: {
        space: '83pwon8meh4m',
        accessToken: 'pfvzL7QUl4oOh0LgiBPwM4ElywOytM5Qhk7udz7UoUY',
        host: 'cdn.contentful.com',
        graphqlAPI:
            'https://graphql.contentful.com/content/v1/spaces/83pwon8meh4m/environments/master',
        graphqlStagingAPI:
            'https://graphql.contentful.com/content/v1/spaces/83pwon8meh4m/environments/master',
    },
    cloudflare: {
        siteKey: '0x4AAAAAAANCj1bc9TY58QXY',
    },
    stripe: {
        publicKey:
            'pk_live_51ALtZbLmSWJTkrFIyIs2Azm8LZn59Vp210Bx5x3FhQmVgOg8scJIbgDfCwLmCzskIdRP7Vho3kGEM0Odsdbu473C00uOTt5A5r',
        publicStagingKey: 'pk_test_GeEtbpZ8SvRIqiTJexMCZDf2',
    },
    revolut: {
        mode: 'prod',
        stagingMode: 'sandbox',
    },
    tapfiliate: {
        accountId: '48981-970970',
    },
    builderIOAPIKey: '0e0e6372c01a4d84b7bc6eb026490e5a',
};
